"use client";
import React, { useState, useRef, useEffect } from "react";
import ICON_ARROW_DOWN from "@/assets/images/arrow_down.svg";
import ICON_ARROW_DOWN_DARK from "@/assets/images/arrow_down_dark.svg";
import "./popupButton.scss";
import { useIsMobile } from "@/lib/isMobile";

const getSelectedOption = (data, type, value) => {
  if (type === "bookmarker_extend") {
    return data.length > 0 ? data[0].name : "";
  }
  if (type === "custom_option") {
    const selected = data.find((bmk) => bmk.value === value);
    return selected?.name ?? "";
  }
  const selected = data.find((bmk) => bmk.value === value);
  return selected?.name ?? "";
};

const PopupButton = ({
  value,
  data,
  handleChange,
  type = "bookmarker_extend",
  isHeaderFixtureResult = false,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const [selectedOption, setSelectedOption] = useState(
    getSelectedOption(data, type, value)
  );
  const [selectedItem, setSelectedItem] = useState(null);
  const popoverRef = useRef(null);
  const isMobile = useIsMobile();

  useEffect(() => {
    setSelectedOption(getSelectedOption(data, type, value));
  }, [value]);

  const togglePopover = () => {
    handleVisible(!isVisible);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    handleVisible(false);
  };

  const handleChangeItem = (item) => {
    setSelectedItem(item);
  };

  const handleVisible = (visible) => {
    if (isMobile) {
      if (visible) {
        document.body.classList.remove("keobongvip-root");
      } else {
        document.body.classList.add("keobongvip-root");
      }
    }

    setIsVisible(visible);
  };

  const handleClickOutside = (event) => {
    if (popoverRef.current && !popoverRef.current.contains(event.target)) {
      handleVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="select-button-date relative inline-block">
      <button
        onClick={togglePopover}
        className={`flex items-center justify-center font-montserrat font-medium text-dark-charcoal gap-2 px-2 py-2 dark:text-stroke-o3 @lg:bg-header-blue bg-white rounded-md ring-1 ring-header-blue dark:ring-0 dark:border-none focus:outline-none h-[24px] ${isHeaderFixtureResult ? "dark:bg-black" : "dark:bg-dark-bg-3"}`}
      >
        {selectedItem?.shortName ? selectedItem.shortName : selectedOption}
        <img
          src={ICON_ARROW_DOWN}
          className="block dark:hidden w-2.5 h-2.5"
        />
        <img
          src={ICON_ARROW_DOWN_DARK}
          className="hidden dark:block w-2.5 h-2.5"
        />
      </button>
      {isVisible && (
        <div className="overlay" onClick={() => handleVisible(false)}></div>
      )}
      <div className={`popup ${isVisible ? "visible" : ""}`} ref={popoverRef}>
        <div className="text-gray-700 dark:text-league-dark-detail">
          <div className="bg-white-half dark:bg-league-white rounded-lg">
            {data.length > 0 &&
              data.map((item, index) => (
                <div
                  key={index}
                  className={`cursor-pointer p-2 hover:bg-gray-200 rounded-lg ${
                    index % 2 !== 0 && "bg-vr-light-gray dark:bg-league-white"
                  } hover:bg-yellow-pastel dark:hover:bg-league-gray-dark`}
                  onClick={() => {
                    handleChange(item.value);
                    handleOptionClick(item.name);
                    handleChangeItem(item);
                  }}
                >
                  {item.name}
                </div>
              ))}
          </div>
          <div
            style={{ marginTop: "0.15rem" }}
            className="px-4 py-4 rounded-md bg-sm-light-gray dark:bg-league-white"
          >
            <button
              style={{ width: "70%" }}
              className="rounded-md bg-white-half dark:bg-gray-400 dark:text-gray-900 p-3"
              onClick={togglePopover}
            >
              Đóng
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(PopupButton);
